import { Pipe, PipeTransform } from '@angular/core';
import { translateOrganizationType } from '../mappers/enum-translation-mapper';
import { OrganizationType } from '../enums/organization-type.enum';

@Pipe({
  name: 'translateOrganizationType',
})
export class TranslateOrganizationTypeEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const enumElement = element as { name: string; index: number };
        enumElement.name = translateOrganizationType(enumElement.index as unknown as OrganizationType);
      });
      return value;
    }
    return translateOrganizationType(value);
  }
}
